import { firestore } from './firebase';

export async function getStore(storeId) {
  try {
    const storeSnapshot = await firestore
      .collection('stores')
      .doc(storeId)
      .get();

    if (storeSnapshot.exists) {
      return storeSnapshot.data();
    }
    return null;
  } catch (error) {
    console.error(error);
  }
}

